// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { InstrumentUtils } from "../../../Utils/Instruments/InstrumentUtils.js";
import { DataCache } from "../../DataCache.js";
import { TerceraSymbolLookupBaseDataProvider } from "../../NoNFixedListCore.js";
import { Instrument } from "../../cache/Instrument.js";

export class TvSearchSymbolManager
{
    private dataProvider: TerceraSymbolLookupBaseDataProvider;

    constructor()
    {
        this.dataProvider = new TerceraSymbolLookupBaseDataProvider();
    }

    public async searchSymbols(userInput: string, exchange: string, symbolType: string): Promise<Instrument[]>
    {
        let filteredInstrumentList: Instrument[] = [];

        if (DataCache.NonFixedList) {
            filteredInstrumentList = await this.getFilteredNonFixedList(userInput);
        }
        else {
            filteredInstrumentList = this.getFilteredFixedList(userInput);
        }
        return filteredInstrumentList;
    }

    private async getFilteredNonFixedList(filter: string): Promise<Instrument[]>
    {
        const nonFixedList = await this.dataProvider.getInstrumentsList(filter,
            null,
            null,
            true,
            true,
            false);
        return nonFixedList;
    }

    getFilteredFixedList(filter: string): Instrument[]
    {
        const defaultInstruments = DataCache.Instruments;
        let filteredInstrumentList: Instrument[] = [];

        for (let insK in defaultInstruments) {
            const ins = defaultInstruments[insK];
            if (!ins || ins.NeedToHide()) {
                continue;
            }

            if (filter !== null) {
                let curItemFindStr = ins.DisplayName();
                let descr = ins.DescriptionValue();
                curItemFindStr = (curItemFindStr + (descr ? " (" + descr + ")" : "")).toLowerCase();
                if (curItemFindStr.toLowerCase().indexOf(filter) === -1)
                    continue;
            }

            filteredInstrumentList.push(ins);
        }
        return filteredInstrumentList;
    }

    public getSymbolByName(nameWithExchange: string): Instrument | null
    {
        if (!nameWithExchange) {
            return null;
        }

        const devidedParts = InstrumentUtils.DivideFullName(nameWithExchange);
        const name = devidedParts.name;
        const exchange = devidedParts.route;

        //кейс, когда видно несколько роутов
        //здесь непонятно как разруливать, поэтому просто берем первый инструмент
        //Нам инструмент заходит в виде EUR/AUD:LMAX, 
        //После разделителя это не роут а биржа, в том виде, в котором он отображается в лукапе TV чарта
        const defaultInstruments = DataCache.Instruments;

        for (let insK in defaultInstruments) {
            const ins = defaultInstruments[insK];
            if (!ins || ins.NeedToHide()) {
                continue;
            }

            if (exchange) {
                const tradingExchage = ins.TradingExchange;
                if (exchange !== tradingExchage)
                    continue;
            }

            if (ins.DisplayName() === name)
            {
                return ins;
            }
        }
        return null;
    }

    public dispose(): void
    {
        this.dataProvider.dispose();
    }
}